// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpExitIntentModal-cls1_Ip2","cls2":"LoswpExitIntentModal-cls2_QKf LoswpExitIntentModal-cls1_Ip2"};